// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue';
import App from './App';
import router from './router';
import store from './store';
// 插入Vant ui 组件库
import Vant, {Lazyload} from 'vant';
import 'vant/lib/index.css';
// 引入pc端兼容
import '@vant/touch-emulator';

Vue.config.productionTip = false;
// 插入Vant ui 组件
Vue.use(Vant);
Vue.use(Lazyload);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: {App},
  template: '<App/>'
});



// WEBPACK FOOTER //
// ./src/main.js